import React from 'react';
import { useLocation } from 'react-router-dom';
import { FiUser } from 'react-icons/fi';
import { useAuth } from '../contexts/AuthContext';
import { useBranding } from '../contexts/BrandingContext';
import GlobalSearch from './GlobalSearch';

const TITLES = {
  '/': 'Dashboard', '/dashboard': 'Dashboard', '/assignments': 'Assignments', '/quick-works': 'Quick Works',
  '/matters': 'Matter / Case Diary', '/clients': 'Clients', '/staff-master': 'Staff Master', '/billing': 'Billing Management',
  '/dsc-management': 'DSC Management', '/communication-centre': 'Communication Centre', '/reports': 'Reports', '/attendance': 'Attendance', '/settings': 'Settings',
  '/branding-settings': 'Branding & Appearance', '/assignment-settings': 'Assignment Types', '/billing-settings': 'Billing Companies',
  '/attendance-settings': 'Attendance Settings', '/quick-work-settings': 'Quick Work Categories'
};

export default function AppHeader() {
  const location = useLocation();
  const { userData } = useAuth();
  const { branding } = useBranding();
  const title = TITLES[location.pathname] || (location.pathname.startsWith('/matters/') ? 'Matter Details' : 'Pravah');

  return (
    <header className="app-header">
      <div className="min-w-0">
        <p className="app-header-organisation-name">{branding.organisationName}</p>
        <h1 className="truncate text-lg font-semibold text-slate-900">{title}</h1>
      </div>

      <div className="app-header-actions">
        <GlobalSearch />
        <div className="app-header-brand" aria-label="Pravah">
          <img src="/brand/pravah-wordmark.png" alt="Pravah" className="app-header-wordmark" />
        </div>

        <div className="hidden items-center gap-3 rounded-xl border border-slate-200 bg-white px-3 py-2 sm:flex">
          <div className="grid h-8 w-8 place-items-center rounded-lg bg-[#0B1F33] text-[#F7F3E8]"><FiUser /></div>
          <div className="leading-tight">
            <p className="text-sm font-semibold text-slate-800">{userData?.name || 'User'}</p>
            <p className="text-xs capitalize text-slate-500">{userData?.role || 'staff'}</p>
          </div>
        </div>
      </div>
    </header>
  );
}
